import styled, { css } from "styled-components";
import { COLORS } from "../../../constants/design/colors";
import { FONT_SIZE } from "../../../constants/design/fontSize";
import { SPACING, BORDER_RADIUS } from "../../../constants/design/spacing";

export const ChipWrapper = styled.span<{ theme: "green" | "blue" | "red" }>`
  font-size: ${FONT_SIZE.xs};
  margin-left: ${SPACING.one}px;
  padding: ${SPACING.one}px ${SPACING.two}px;
  border-radius: ${BORDER_RADIUS.two}px;

  ${({ theme }) => {
    switch (theme) {
      case "green":
        return css`
          background-color: ${COLORS.up.five} !important;
          color: ${COLORS.up.one} !important;
        `;
      case "blue":
        return css`
          background-color: ${COLORS.blue.two} !important;
          color: ${COLORS.blue.two} !important;
        `;
      case "red":
        return css`
          background-color: ${COLORS.down.five} !important;
          color: ${COLORS.down.one} !important;
        `;
      default:
        return "";
    }
  }}
`;
